export default "/_next/static/images/wag-expandable-bowl-2x-561cabd2614d775a2ec507139cdd50e8.png";